import { AccesoEstado } from "../common/enumModel";
import { IAccesoModel } from "../interfaces/accesos/IAccessoModel";


export class AccesoModel implements IAccesoModel {
    idAccesoPersonal: number;
    nombres:string;
    apellidoPaterno:string;
    apellidoMaterno:string;
    nroDocumentoIdentidad: string;
    cargo: string;
    idEstado: AccesoEstado;
    estado: string;
    fechaInicio: Date;
    fechaFin: Date;
    // documentos_requeridos: Array<DocumentacionRequeridaModel>;

    constructor(){
        this.idAccesoPersonal = 0;
        this.nombres = '';
        this.apellidoPaterno = '';
        this.apellidoMaterno = '';
        this.nroDocumentoIdentidad = '';
        this.cargo = '';
        this.idEstado = AccesoEstado.AUTORIZADO;
        this.estado = '';
        this.fechaInicio = new Date();
        this.fechaFin = new Date();
    }
}